import { render, staticRenderFns } from "./AddTargetBasedBarTrendWidget.vue?vue&type=template&id=e38a9df8"
import script from "./AddTargetBasedBarTrendWidget.vue?vue&type=script&lang=js"
export * from "./AddTargetBasedBarTrendWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports